// extracted by mini-css-extract-plugin
export default {"collection":"ConsentsCollection_collection__BSmJu","item":"ConsentsCollection_item__8Zdg3","header":"ConsentsCollection_header__D2ch-"};